<template>
    <div id="partneri" class="PartnersBlock flex flex-col items-center pb-32 pt-24">
        <CHeading class="mb-8 text-center" :variant="2"> Organizácie na GROWNi </CHeading>
        <p class="mb-4 text-center text-smaller">
            GROWNi je súčasťou neziskovej organizácie <strong>LEAF</strong>. <br />
            Na tvorbe platformy sa podieľa aj <strong>DASATO</strong> (I AMbitious).
        </p>

        <div class="mb-10 grid grid-cols-2 gap-8">
            <PartnersBlockItem
                v-for="(partner, index) in partners.slice(0, 2)"
                :key="index"
                :alt="partner.alt"
                :height="partner.height"
                :href="partner.link"
                :image-src="partner.src"
                target="_blank"
                :width="partner.width"
            />
        </div>
        <div class="grid grid-cols-2 gap-8 gap-y-12 md:grid-cols-4">
            <PartnersBlockItem
                v-for="(partner, index) in partners.slice(2)"
                :key="index"
                :alt="partner.alt"
                :height="partner.height"
                :href="partner.link"
                :image-src="partner.src"
                target="_blank"
                :width="partner.width"
            />
            <PartnersBlockItem class="text-center font-semibold uppercase" :href="'/organizacie'">
                Zobraziť<br />všetky organizácie
            </PartnersBlockItem>
        </div>
    </div>
</template>

<script setup lang="ts">
import PartnersBlockItem from '@/components/common/PartnersBlockItem.vue'
import CHeading from '@/components/ui/CHeading.vue'
import { computed } from 'vue'

interface Props {
    studentPartners?: boolean
}
const props = defineProps<Props>()

interface Partner {
    src: string
    alt: string
    width: number
    height: number
    link?: string
}

const partners = computed<Partner[]>(() => {
    if (props.studentPartners) {
        return [
            {
                src: '/images/partneri/logo-leaf.png',
                alt: 'LEAF logo',
                width: 141,
                height: 61
            },
            {
                src: '/images/partneri/logo-iambitious.png',
                alt: 'IAmbitious logo',
                width: 141,
                height: 61
            },
            {
                src: '/images/partneri/logo-amcham.png',
                alt: 'AmCham Slovakia logo',
                width: 141,
                height: 61
            },
            {
                src: '/images/partneri/logo-nexteria.png',
                alt: 'Organizácia Nexteria logo',
                width: 158,
                height: 57
            },
            {
                src: '/images/partneri/logo-sokratov-institut.png',
                alt: 'Sokratov inštitút logo',
                width: 142,
                height: 49
            },
            {
                src: '/images/partneri/logo-tech-for-slovakia.png',
                alt: 'Tech for Slovakia logo',
                width: 142,
                height: 49
            },
            {
                src: '/images/partneri/logo-kancelaria-prezidenta-sr.png',
                alt: 'Kancelária prezidentky Slovenskej republiky logo',
                width: 142,
                height: 49
            }
        ]
    } else {
        return [
            {
                src: '/images/partneri/logo-leaf.png',
                alt: 'LEAF logo',
                width: 219,
                height: 49,
                link: 'https://growni.sk/orgs/leaf'
            },
            {
                src: '/images/partneri/logo-dasato.png',
                alt: 'IAmbitious logo',
                width: 142,
                height: 49,
                link: 'https://growni.sk/orgs/i-ambitious'
            },
            {
                src: '/images/partneri/logo-nexteria.png',
                alt: 'Organizácia Nexteria logo',
                width: 158,
                height: 57,
                link: 'https://growni.sk/orgs/nexteria'
            },
            {
                src: '/images/partneri/logo-google.png',
                alt: 'Google Slovensko logo',
                width: 142,
                height: 49,
                link: 'https://growni.sk/orgs/google-slovensko'
            },
            {
                src: '/images/partneri/logo-transparency-international.png',
                alt: 'Transparency International logo',
                width: 219,
                height: 51,
                link: 'https://growni.sk/orgs/transparency-international-slovensko'
            },
            {
                src: '/images/partneri/logo-slovenska-sporitelna.png',
                alt: 'Slovenská sporiteľňa logo',
                width: 219,
                height: 51,
                link: 'https://growni.sk/orgs/slovenska-sporitelna-a-s'
            },
            {
                src: '/images/partneri/logo-rozbehni-sa.png',
                alt: 'Rozbehni sa logo',
                width: 100,
                height: 100,
                link: 'https://growni.sk/orgs/rozbehni-sa'
            },
            {
                src: '/images/partneri/logo-bloomreach.png',
                alt: 'Bloomreach logo',
                width: 128,
                height: 88,
                link: 'https://growni.sk/orgs/bloomreach'
            },
            {
                src: '/images/partneri/logo-mesto-bratislava.png',
                alt: 'Mesto Bratislava logo',
                width: 141,
                height: 61,
                link: 'https://growni.sk/orgs/hlavne-mesto-sr-bratislava'
            },
            {
                src: '/images/partneri/logo-trama-tm.svg',
                alt: 'TramaTM logo',
                width: 155,
                height: 45,
                link: 'https://growni.sk/orgs/trama-tm-s-r-o'
            },
            {
                src: '/images/partneri/logo-nadacia-pontis.svg',
                alt: 'Nadácia Pontis logo',
                width: 155,
                height: 155,
                link: 'https://growni.sk/orgs/nadacia-pontis'
            },
            {
                src: '/images/partneri/logo-utvar-hodnoty-za-peniaze.png',
                alt: 'Útvar hodnoty za peniaze logo',
                width: 100,
                height: 100,
                link: 'https://growni.sk/orgs/utvar-hodnoty-za-peniaze'
            },
            {
                src: '/images/partneri/logo-pixel-federation.png',
                alt: 'Pixel Federation logo',
                width: 151,
                height: 84,
                link: 'https://growni.sk/orgs/pixel-federation-s-r-o'
            }
        ]
    }
})
</script>
